import { render, staticRenderFns } from "./CustomService.vue?vue&type=template&id=7032c28a&scoped=true&lang=pug"
import script from "./CustomService.vue?vue&type=script&lang=js"
export * from "./CustomService.vue?vue&type=script&lang=js"
import style0 from "./CustomService.vue?vue&type=style&index=0&id=7032c28a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032c28a",
  null
  
)

export default component.exports